<template>

 <v-container class="grey lighten-5" v-if='task'>
     <v-alert v-if='task.status === "completed"'
      v-model="alert"
      color="orange"
      border="left"
      elevation="2"
      colored-border
      icon="mdi-alert"
    >
     This task is marked as completed, no further action is needed.
    </v-alert>

  
    <v-row>
        <v-col class='col-8'>
          <v-card>
     <v-overlay absolute :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
      <iframe v-if='fileLink' :src="fileLink" width="100%" height="800px"></iframe>
          </v-card>
        </v-col>
      <v-col>
           <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-card-text>
      <div>User:</div>
      <p class="headline text--primary">
        {{task.data.email}}
      </p>
      <p>File upload date:</p>
      <div class="text--primary">
       {{task.createdDate}}
      </div>
      <div class='mt-5'>
      <v-btn @click='patientProfile()' class='mb-2' depressed color="primary">User Profile</v-btn>
      <br />
       <v-btn v-if='task.status !== "completed"' @click='completeTask()' class='mr-2' depressed color="info">Complete Task</v-btn>
        <v-btn v-if='task.status !== "completed"' @click='removeTask()' depressed color="error">Remove Task</v-btn>
        </div>
    </v-card-text>
  </v-card>
        
      
      </v-col>
    </v-row>
  </v-container>



</template>

<script>
import { postReq } from '../../helper/firestore'
import { mapFields } from 'vuex-map-fields';
export default {
    data() {
        return{
          alert : true,
            overlay : true,
            task : null,
            fileLink : null
        }
    },
      computed: {
    ...mapFields([
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
  },
    methods : {
      completeTask(){
            postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/completeTask',{taskId :this.$route.params.taskId},(res)=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = res.data
          this.$router.push('/tasks')
        })
      },
            removeTask(){
         postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/deleteTask',{taskid :this.$route.params.taskId},()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "Update complete"
          this.$router.push('/tasks')
        })
       
      },
        patientProfile(userEmail){
            this.$router.push('/user/email/'+this.task.data.email)
        },
        fetchFile(filePath){
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/patients/getFileURL',{url : filePath},(response)=>{
            this.fileLink = response.data;
            this.overlay = false;
        })
        }
    },
    mounted(){
            postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/getTaskById',{docID:this.$route.params.taskId},result=>{
            this.task = result.data[0];
            this.fetchFile(this.task.data.filePath)
            })
    }
}
</script>

<style>

</style>